import { ElementStore } from 'component/Carousel/store/ElementStore'

export function getBest(element: ElementStore): number {
  const { position } = element
  return Math.round(position - 0.5)
}
